// extracted by mini-css-extract-plugin
module.exports = {"navititle":"Navibar_navititle__3NRRO","navilink":"Navibar_navilink__2sCqz","navilinkUnderline":"Navibar_navilinkUnderline__3Ho5O"};